import { useMemo } from "react";
import { trpc } from "@/hooks/trpc";
import type { FormulaContextInput, FormulaContextSpec } from "../context";

/**
 * Fetches the server-built formula context for a specific formula site.
 * Returns null while loading — callers should render a disabled editor
 * or skeleton until the context resolves.
 */
export function useFormulaContext(
  input: FormulaContextInput | null,
): FormulaContextSpec | null {
  const { data } = trpc.formulas.getContext.useQuery(
    input as FormulaContextInput,
    { enabled: !!input },
  );
  return useMemo(() => (data as FormulaContextSpec | undefined) ?? null, [data]);
}
